import { z } from "zod";

export const userProfileSchema = z.object({
  email: z.string(),
  name: z.string(),
  jobTitle: z.string().optional(),
  company: z.string().optional(),
  avatar: z.string().optional(),
  bio: z.string().optional(),
  linkedinUrl: z.string().optional(),
  // Sharing choices. Absent means the default: LinkedIn shown, email hidden.
  // Saved on their own, not with the form (see useSaveSharing).
  showLinkedin: z.boolean().optional(),
  showEmail: z.boolean().optional(),
  platformRole: z.enum(["user", "admin", "super_admin"]).optional(),
  hasInternalAttendeeProfile: z.boolean().optional(),
  createdAt: z.any().optional(),
});

export type UserProfile = z.infer<typeof userProfileSchema>;

const UPDATABLE_FIELDS = [
  "name",
  "jobTitle",
  "company",
  "avatar",
  "bio",
  "linkedinUrl",
] as const;

export const profileUpdateSchema = z.object({
  name: z.string().min(1),
  jobTitle: z.string().optional(),
  company: z.string().optional(),
  avatar: z.string().optional(),
  bio: z.string().optional(),
  linkedinUrl: z.string().optional(),
});

export type ProfileUpdate = z.infer<typeof profileUpdateSchema>;

export function projectUpdateFields(
  data: Record<string, unknown>,
): ProfileUpdate {
  const projected: Record<string, unknown> = {};
  for (const key of UPDATABLE_FIELDS) {
    if (key in data) {
      projected[key] = data[key];
    }
  }
  return profileUpdateSchema.parse(projected);
}

export type SharingChoice = "showLinkedin" | "showEmail";

/** What other attendees see when a choice has never been made. */
export const SHARING_DEFAULTS: Record<SharingChoice, boolean> = {
  showLinkedin: true,
  showEmail: false,
};
